import React from 'react';
import classnames from 'classnames';
import { TThumbnail } from '../UploadingFileThumbnail.types';
import styles from '../UploadingFileThumbnail.scss';

export const Folder: TThumbnail = ({ fallbackImageClassName }) => (
  <div className={classnames(styles.contentWrapper, styles.folder)} data-hook="uploading-file-thumbnail-folder">
    <div className={classnames(styles.content, fallbackImageClassName)} />
  </div>
);
